
import { lineWobble } from 'ldrs'

lineWobble.register()

// Default values shown
{/* <l-line-wobble
  size="80"
  stroke="5"
  bg-opacity="0.1"
  speed="1.75" 
  color="black" 
></l-line-wobble> */}


function MEILoader({ showLoader }) {

    if (!showLoader) {
        return (<></>)
    }

    return (
        <div style={{
            background: '#2c7be566',
            background: 'linear-gradient(to right, #2c7be54D, #2c7be58C)',
            position: 'absolute',
            borderRadius: 12,
            zIndex: 9999,
            top: '40%',
            left: '30%',
            height: '150px',
            width: '300px',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <l-line-wobble
                size="200"
                stroke="5"
                bg-opacity="0.1"
                speed="1.75"
                color="#2c7be5"
            ></l-line-wobble>
        </div>

    )

}

export default MEILoader;